import { css } from 'styled-components';

export const pickerBubbleStyle = css`
  border: 1px solid transparent;

  .rc-picker-range-separator {
    color: #333d6c;
  }

  &.rc-picker-range,
  & {
    /* width: min-content; */
    padding: 2px;
    border-radius: 13px;
    background: #f7f7f9;

    .rc-picker-input {
      height: 32px;
      min-width: 82px;
      padding: 4px;

      > input {
        padding: 4px 16px;
        border: 1px solid transparent;
        border-radius: 8px;
        outline: none;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;

        /* or 286% */

        text-align: center;
        color: #333d6c;

        &:focus {
          border: 1px solid rgba(51, 61, 108, 0.5);
        }

        &::placeholder {
          color: rgba(51, 61, 108, 0.7);
        }
      }
    }

    .rc-picker-suffix {
      z-index: 0;
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin-left: 4px;
      display: block;
      position: relative;
    }

    .rc-picker-suffix + .rc-picker-clear {
      position: absolute;
      top: 4px;
      right: 4px;
      color: #00000040;
      line-height: 1;
      background: #fff;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s, color 0.3s;
      z-index: 1;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }

    .rc-picker-clear {
      top: 5px;
      right: 12px;
      color: #00000040;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s, color 0.3s;
      z-index: 1;

      .rc-picker-clear-btn::after {
        content: '×';
        color: #333d6c;
        line-height: 1;
        top: -2px;
        position: relative;
      }
    }

    &:hover {
      .rc-picker-clear {
        visibility: visible;
        opacity: 1;
        transition: all 0.2s;
      }
    }

    .rc-picker-active-bar {
      margin-left: 12px;
      display: none;
    }
  }
`;

export const pickerInlineStyle = css`
  border: 1px solid transparent;
  transition: all 0.2s;

  .rc-picker-range-separator {
    color: #333d6c;
  }

  &.rc-picker-range,
  & {
    /* width: min-content; */
    padding: 2px;
    background: transparent;
    border-bottom: 1px solid #333d6c;

    .rc-picker-input {
      height: 32px;
      min-width: 82px;
      padding: 4px;

      > input {
        padding: 4px 16px;
        border: 1px solid transparent;
        border-radius: 8px;
        outline: none;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;

        /* or 286% */

        text-align: center;
        color: #333d6c;
        background: transparent;

        &:focus {
          border: 1px solid rgba(51, 61, 108, 0.5);
        }

        &::placeholder {
          color: rgba(51, 61, 108, 0.7);
        }
      }
    }

    .rc-picker-suffix {
      z-index: 0;
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin-left: 4px;
      display: block;
      position: relative;
    }

    .rc-picker-suffix + .rc-picker-clear {
      position: absolute;
      top: 6px;
      right: 2px;
      color: #00000040;
      line-height: 1;
      background: #fff;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s, color 0.3s;
      z-index: 1;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }

    .rc-picker-clear {
      top: 4px;
      right: 10px;
      color: #00000040;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s, color 0.3s;
      z-index: 1;

      .rc-picker-clear-btn::after {
        content: '×';
        color: #333d6c;
        line-height: 1;
        top: -2px;
        position: relative;
      }
    }

    &:hover {
      .rc-picker-clear {
        visibility: visible;
        opacity: 1;
        transition: all 0.2s;
      }
    }

    .rc-picker-active-bar {
      margin-left: 12px;
      display: none;
    }
  }
`;

export const pickerCommonStyles = css`
  .rc-picker-week-panel-row {
    .rc-picker-cell {
      background: #fff;
    }

    &:hover,
    &.rc-picker-week-panel-row-selected {
      background: #f5f5f7;

      .rc-picker-cell-inner {
        background: #f5f5f7;
      }
    }
  }

  .rc-picker-time-panel-cell-disabled {
    opacity: 0.4;
  }

  .rc-picker-dropdown,
  .rc-picker-panel {
    border: none;
    box-shadow: none;
    z-index: 99999;
  }

  .rc-picker-range-wrapper .rc-picker-time-range-wrapper {
    border: none;
  }

  .rc-picker-dropdown {
    .rc-picker-panel {
      box-shadow: none;
    }
  }

  .rc-picker-panel {
    background: #fff;
    border: none;
    box-shadow: 0 2px 15px rgba(24, 30, 52, 0.2);
  }

  .rc-picker-range-arrow {
    border: none;
    box-shadow: none;
    outline: none;

    &::after,
    &::before {
      background: #fff !important;
      border: none !important;
    }
  }

  .rc-picker-panel-container {
    box-shadow: 0 2px 15px rgba(24, 30, 52, 0.2);
  }

  .rc-picker-panel-container,
  .rc-picker-panel {
    background: #fff;
    border-radius: 8px;
    border: none;
    overflow: hidden;

    .rc-picker-time-panel-column {
      border-right: 2px solid transparent;
      width: 58px;

      &:not(:last-child) {
        border-right: 2px solid #f5f5f7;
      }

      .rc-picker-time-panel-cell {
        .rc-picker-time-panel-cell-inner {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 14px;

          /* or 100% */

          color: #333d6c;
        }

        padding: 4px;

        &.rc-picker-time-panel-cell-selected {
          background: #f5f5f7;

          .rc-picker-time-panel-cell-inner {
            font-weight: bold;
          }
        }
      }
    }

    .rc-picker-header {
      padding: 8px;
      padding-bottom: 0;
      background: #fff;

      button {
        padding: 4px 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #333d6c;
        cursor: pointer;
        border: none;
        border-radius: 8px;
        background: #fff;

        :hover {
          color: #58dbea;
        }
      }

      .rc-picker-header-next-btn,
      .rc-picker-header-super-next-btn,
      .rc-picker-header-prev-btn,
      .rc-picker-header-super-prev-btn {
        height: 20px;
        margin-top: 5px;

        svg {
          height: 100%;
        }
      }
    }

    .rc-picker-body,
    .rc-picker-content {
      width: 100%;
      padding: 8px 4px;

      thead {
        tr {
          border-top: 1px solid #d7d9e2;
          border-bottom: 1px solid #d7d9e2;
        }

        th {
          padding: 8px 0;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;

          /* identical to box height, or 125% */

          text-align: center;
          color: #181e35;
          mix-blend-mode: normal;
          opacity: 0.6;
        }
      }

      tbody {
        td.rc-picker-cell {
          border-collapse: collapse;

          &:hover {
            background: rgba(51, 61, 108, 0.1) !important;
          }

          &.rc-picker-cell-selected {
            background: rgba(51, 61, 108, 0.1) !important;

            .rc-picker-cell-inner {
              border: none;
              background: none;
            }
          }

          &.rc-picker-cell-in-view,
          &.rc-picker-cell-today {
            background: #fff;

            .rc-picker-cell-inner {
              opacity: 1;
              border: none;
            }
          }

          &.rc-picker-cell-today {
            .rc-picker-cell-inner {
              color: #f54497;
            }
          }

          &-range-start,
          &-range-end,
          &-range-hover-start,
          &-range-hover,
          &-range-hover-end {
            background: #def0e6 !important;

            .rc-picker-cell-inner {
              border: none;
              background: none;
            }
          }

          &-in-range {
            border-top: 2px solid white;
            border-bottom: 2px solid white;
            background: #def0e6 !important;

            .rc-picker-cell-inner {
              background: #def0e6 !important;
              color: #6ae59f !important;
            }
          }

          &-range-hover-start,
          &-range-start {
            background: #98f0bf !important;
            border-top-left-radius: 50%;
            border-bottom-left-radius: 50%;
            border-top: 2px solid white;
            border-bottom: 2px solid white;

            .rc-picker-cell-inner {
              background: none;
              color: #333d6c !important;
            }
          }

          &-range-hover-end,
          &-range-end {
            background: #98f0bf !important;
            border-top-right-radius: 50%;
            border-bottom-right-radius: 50%;
            border-top: 2px solid white;
            border-bottom: 2px solid white;

            .rc-picker-cell-inner {
              background: none;
              color: #333d6c !important;
            }
          }

          &-range-hover-start,
          &-range-hover-end,
          &-range-hover {
            border-top: 2px solid white !important;
            border-bottom: 2px solid white !important;

            &::after {
              content: '';
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              border: none !important;
              border-left: 0;
              border-right: 0;
              pointer-events: none;
            }
          }

          &-range-hover-start::after {
            border-left: none !important;
          }

          &-range-hover-end::after {
            border-right: none !important;
          }

          .rc-picker-cell-inner {
            opacity: 0.3;
            min-width: 35px;
            min-height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;

            /* identical to box height, or 143% */

            text-align: center;
            color: #181e34;

            &:hover {
              background: none !important;
            }
          }
        }
      }
    }

    .rc-picker-date-panel {
      width: 280px;
    }

    .rc-picker-decade-panel {
      .rc-picker-content {
        td {
          .rc-picker-cell-inner {
            padding: 10px;
          }
        }
      }
    }

    .rc-picker-footer {
      background: #fff;
      padding: 8px 4px;

      .rc-picker-ok {
        button {
          padding: 4px 8px;
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 14px;
          background: #333d6c;
        }
      }

      .rc-picker-now-btn {
        cursor: pointer;
      }
    }
  }
`;

export const pickerHistoryStyle = css`
  border: 1px solid transparent;

  .rc-picker-range-separator {
    color: #333d6c;
    opacity: 0.3;
    padding: 4px 0;
  }

  &.rc-picker-range,
  & {
    width: 100%;
    padding: 2px;
    border-radius: 10px;
    background: white;

    .rc-picker-input {
      height: 32px;
      min-width: 82px;
      padding: 4px;

      > input {
        padding: 4px 0;
        border: 1px solid transparent;
        border-radius: 8px;
        outline: none;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;

        /* or 286% */

        text-align: center;
        color: #333d6c;
        opacity: 0.3;

        &:focus {
          border: 1px solid rgba(51, 61, 108, 0.5);
        }

        &::placeholder {
          color: rgba(51, 61, 108, 0.7);
        }
      }
    }

    .rc-picker-suffix {
      z-index: 0;
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin-left: 4px;
      display: block;
      position: relative;
    }

    .rc-picker-suffix + .rc-picker-clear {
      position: absolute;
      top: 4px;
      right: 4px;
      color: #00000040;
      line-height: 1;
      background: #fff;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s, color 0.3s;
      z-index: 1;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }

    .rc-picker-clear {
      top: 5px;
      right: 12px;
      color: #00000040;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s, color 0.3s;
      z-index: 1;

      .rc-picker-clear-btn::after {
        content: '×';
        color: #333d6c;
        line-height: 1;
        top: -2px;
        position: relative;
      }
    }

    &:hover {
      .rc-picker-clear {
        visibility: visible;
        opacity: 1;
        transition: all 0.2s;
      }
    }

    .rc-picker-active-bar {
      margin-left: 12px;
      display: none;
    }
  }
`;
